export const actionsOnStudents = {
  translate: 'Перевод',
  'un-translate': 'Отмена перевода',
  remove: 'Удаление',
  add: 'Приглашение'
}
